export default __webpack_public_path__ + "static/replace_it-b66cb175a74e416f33e382974f017509.jpg";